import { Card, Typography } from "antd";
import Chart from "react-apexcharts";
import React from "react";

export default function MostClaimedTreatments() {
  const series = [
    {
      name: "Claims",
      data: [85, 70, 65, 90, 75],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 250,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "20%",
        borderRadius: 6,
        endingShape: "rounded",
      },
    },
    dataLabels: { enabled: false },
    colors: ["#6B43B5"],
    xaxis: {
      categories: ["Scaling", "Root Planing", "Root Planing", "Root Planing", "Root Planing"],
      labels: {
        style: { fontSize: 11, colors: "#979797" },
        rotate: -45,
        rotateAlways: true,
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        formatter: (val) => `${val}%`,
        style: { fontSize: 12, colors: "#979797" },
      },
    },
    grid: { show: false },
    tooltip: { y: { formatter: (val) => `${val}%` } },
  };

  return (
    <Card style={{ minWidth: 351, height: 350 }}>
      <Typography.Title level={4} style={{ marginBottom: 20 }}>
        Most Claimed Treatments
      </Typography.Title>
      <Chart options={options} series={series} type="bar" height={250} />
    </Card>
  );
}
